// DEPRECATED - disconnected from Optimizely - removal pending
import { onboardingFeatures } from 'client/GrowthEngineering/utilities/GrowthConstants';
import DateUtil from 'client/util/DateUtil';
import MspState from 'client/components/models/MspState';
import store from 'client/store/index';

const growthModule = 'GrowthModule';
const onboardingModule = 'OnboardingModule';
const settings = 'SettingsModule';

const orgCreatedDate = () => store.getters['OrganizationsCollection/getOrgCreatedDate'];

/**
 * A list of page view events. These events are specifically used to begin Optimizely experiments.
 */
export const pageViewEvents = {
  adminPortalConsole: 'adminPortalConsole',
  conditionalAccessPoliciesPage: 'conditionalAccessPoliciesPage',
  ldapPage: 'ldapPage',
  notMspNorCommandRunner: 'notMspNorCommandRunner',
  signup: 'signup_product',
  signupAdminPortalCrossover: 'signupAdminPortalCrossover',
  supportPage: 'adminPortalSupport',
  newSystemPage: 'newSystemPage',
  windowsAppModal: 'windowsAppModal',
};

/**
 * A list of Optimizely experiments.
 * @property {Number} experimentId - The id of the experiment. Returned in Optimizely's `state`
 * object.
 * @property {String} name - The name of the experiment. Returned in Optimizely's `state` object.
 * @property {String} pageViewEvent - The API name of the page view event that triggers the
 * experiment
 * @property {String} startDate - The date the experiment was started
 * @property {Boolean} showToOlderOrgs - Set to true to show the experiment to organizations
 * created before the experiment start date
 * @property {Object} variations - An array of the names of the possible variations a user may
 * be shown
 */
export const experiments = {
  landingPage: {
    experimentId: 20097032647,
    name: 'Landing Page',
    startDate: '2021/03/24',
    variations: {
      user: 'User Page',
      home: 'Home Page',
    },
  },
  optimizelyAudienceTester: {
    experimentId: 20236109620,
    name: 'Optimizely Audience Tester',
    pageViewEvent: pageViewEvents.notMspNorCommandRunner,
    startDate: '2000-01-01',
    variations: {
      original: 'Original',
      new: 'In Audience',
    },
  },
  recommendPackageInChecklist: {
    experimentId: 21068300477,
    name: 'Recommended Package in Implementation Checklist',
    pageViewEvent: pageViewEvents.notMspNorCommandRunner,
    startDate: '2022-01-14',
    showToOlderOrgs: true,
    variations: {
      original: 'Original',
      new: 'Show Recommended Package',
    },
  },
  remoteAssistOnboarding: {
    experimentId: 23404471323,
    name: 'Remote Assist Onboarding',
    pageViewEvent: pageViewEvents.notMspNorCommandRunner,
    startDate: '2023-03-02',
    variations: {
      original: 'Original',
      onboardingWizard: 'Onboarding Wizard',
      simulation: 'Simulation Walkthrough',
    },
    /**
     * Custom eligibility check for the Remote Assist Onboarding experiment
     * @returns {Boolean} - Returns true for eligible admins
     */
    eligibilityCheck: (
      () => {
        const { directOnboardingFeature } = store.state[onboardingModule];
        return directOnboardingFeature === onboardingFeatures.remoteAssist;
      }
    ),
  },
  ssoNavBarRenaming: {
    experimentId: 22640402990,
    name: 'Nav bar SSO',
    pageViewEvent: pageViewEvents.notMspNorCommandRunner,
    startDate: '2023-01-17',
    showToOlderOrgs: false,
    variations: {
      original: 'Original',
      new: 'Applications',
    },
  },
};

const getOrgCreatedAfterExperimentStartDate = (experiment) => {
  try {
    if (!experiment || !experiment.startDate) return false;

    const experimentStartDate = new Date(experiment.startDate);
    const orgCreatedAfterStartDate = !!DateUtil.isAfterDate(orgCreatedDate(), experimentStartDate);
    return orgCreatedAfterStartDate;
  } catch (e) {
    // just return false and move on
    return false;
  }
};

/**
 * Helper functions for tracking Optimizely page view events
 */
const trackAdminPortalConsoleView = () => {

};

const trackNotMspNorCommandRunner = () => {

};

const trackWindowsAppModal = () => {

};

const trackSignupAdminPortalCrossoverView = () => {

};

const trackLdapPageView = () => {

};

const shouldShowHomeAsLandingPage = () => {
  // Orgs without feature flag should see users page
  let showHomeAsLandingPage = false;
  // Orgs created before the experiment date should see the home page
  showHomeAsLandingPage = true;
  const homeStartDate = new Date(experiments.landingPage.startDate);

  // Orgs created after the launch of the home page should get the experiment
  if (DateUtil.isAfterDate(orgCreatedDate(), homeStartDate)) {
    const variation = '';
    if (variation === experiments.landingPage.variations.user) showHomeAsLandingPage = false;
  }
  return showHomeAsLandingPage;

  // if the beta flag exists, do all the stuff otherwise show the old experience
};

/**
 * This is a special experiment to Test Optimizely Audiences
 * The tester can check local storage to see if the applied audiences are working for the org
 * Audience: All users, 100% to new variation
 */
const getOptimizelyAudienceTesterVariation = () => {
  try {
    const variation = '';
    const inAudience = Boolean(variation === experiments.optimizelyAudienceTester.variations.new);
    localStorage.setItem('jcInAudience', inAudience);
  } catch (e) {
    // just catch and move on
  }
};

/**
 * Helper function to get the experiment variation
 * @param {Object} experiment - The experiment object
 * @returns {boolean}
 */
const getExperimentVariation = (experiment) => {
  try {
    // if experiment is not valid, return false
    if (!experiment || !experiment.variations) return false;

    // unless experiment is set to display to older organizations,
    // return false if organization is created before experiment start date
    if (!experiment.showToOlderOrgs) {
      const orgCreatedAfterStartDate = getOrgCreatedAfterExperimentStartDate(experiment);
      if (!orgCreatedAfterStartDate) return false;
    }

    const variation = '';

    if (variation === 'Original') {
      return false;
    }

    // variation will return as an empty string if it is not active
    return !!variation;
  } catch (e) {
    // just return false and move on
    return false;
  }
};

const getExperimentVariationName = () => '';

const optimizelyPageView = () => {
  const { isCommandRunner, orgId } = store.state[settings];

  // Triggers events used to begin relevant Optimizely experiments
  trackAdminPortalConsoleView();
  trackWindowsAppModal();
  trackSignupAdminPortalCrossoverView();

  if (!isCommandRunner && !MspState.isAnMsp && orgId) {
    trackNotMspNorCommandRunner();
    getOptimizelyAudienceTesterVariation();
  }
};

export const optimizelySetup = () => {
  optimizelyPageView();
  store.dispatch(`${growthModule}/updateOptimizelyLoaded`, true);
};

export default {
  getExperimentVariation,
  getExperimentVariationName,
  getOptimizelyAudienceTesterVariation,
  shouldShowHomeAsLandingPage,
  trackAdminPortalConsoleView,
  trackLdapPageView,
  trackNotMspNorCommandRunner,
  trackSignupAdminPortalCrossoverView,
  trackWindowsAppModal,
};
